import { BackendServiceName } from 'v2/types'
import { createService } from './create-service'

export const configService = createService('/contacto-config', true, BackendServiceName.core, 'v1')
export const baseService = createService('', true, BackendServiceName.default)
export const coreService = createService('', true, BackendServiceName.core, 'v1')
export const globalHodorService = createService('', false, BackendServiceName.default, 'v1')
// Hodor proxies /v2/* to cx-flow-runner — used to trigger legacy (migrated) phlos.
export const globalHodorServiceV2 = createService('', false, BackendServiceName.default, 'v2')
// agent-runner endpoints go through global hodor's authenticated /v1 proxy.
export const runnerService = globalHodorService
